import { Link } from 'react-router-dom'
import { Heart } from 'lucide-react'

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <span style={{ color: '#0fbab2', fontWeight: '600' }}>Qmed Nursing Care Plans</span>
          </Link>
        </div>
      </div>
    </header>
  )
}

export default Header
